import firebase from "firebase/app";
import "firebase/auth";
import "firebase/storage";

const generalConfig = {
  apiKey: "AIzaSyCrhSBJYHmMTBdpKp7chq4fzPM9x31vWrs",
  authDomain: "abacus-assets.firebaseapp.com",
  databaseURL: "https://abacus-assets.firebaseio.com",
  projectId: "abacus-assets",
  storageBucket: "abacus-assets.appspot.com",
  messagingSenderId: "402374796456",
  appId: "1:402374796456:web:2cc44f8157d995bae8ce9d",
  measurementId: "G-SY9YDQ79QF"
};

const releaseConfig = {
  apiKey: "AIzaSyCrhSBJYHmMTBdpKp7chq4fzPM9x31vWrs",
  authDomain: "abacus-assets.firebaseapp.com",
  databaseURL: "https://abacus-assets.firebaseio.com",
  projectId: "abacus-assets",
  storageBucket: "abacus-assets.appspot.com",
  messagingSenderId: "402374796456",
  appId: "1:402374796456:web:2cc44f8157d995bae8ce9d",
  measurementId: "G-SY9YDQ79QF"
};

firebase.initializeApp(process.env.NODE_ENV == "production" ? releaseConfig : generalConfig, "kiosk");

/*
  setLogLevel param:
- debug for the most verbose logging level, primarily for debugging.
- error to log errors only.
- silent to turn off logging.
*/
if (process.env.NODE_ENV == "production") {
  firebase.firestore.setLogLevel("error");
} else {
  firebase.firestore.setLogLevel("error");
}

export const storage = firebase.storage();
